import { translate, TranslateModifiers } from '@core/translate';
import { classMap, Component, css, html, LitElement, property, styleMap } from '@rxdi/lit-html';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * @customElement dropdown-component
 */
@Component({
  selector: 'dropdown-component',
  modifiers: [...TranslateModifiers],
  style: css`
    .dropbtn {
      background-color: #3498db;
      color: white;
      padding: 16px;
      font-size: 16px;
      border: none;
      cursor: pointer;
    }

    .dropbtn:hover,
    .dropbtn:focus {
      background-color: #2980b9;
    }

    .dropdown {
      position: relative;
      display: inline-block;
      transition: all 0.5s ease;
    }

    .dropdown-content {
      display: none;
      position: absolute;
      background-color: var(--global-dropdown-menu-bg, #edf2fa);
      overflow: auto;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      z-index: 10;
    }

    .dropdown-content .item {
      color: black;

      text-decoration: none;
      display: block;
      cursor: pointer;
    }

    .padding {
      padding: 12px 16px;
    }

    .border {
      border-bottom: 1px solid #d4d4d4;
    }

    .dropdown .item:hover {
      background-color: #e5eaf2;
    }

    .show {
      display: block;
    }
    .left {
      margin-left: -320px;
      margin-top: -5px;
    }
    .hover {
      background-color: white;
    }
  `,
  template(this: DropdownComponent) {
    return html`
      <div
        class="dropdown"
        style=${this.$style}
        @mouseenter=${() => (this.entered = true)}
        @mouseleave=${() => (this.entered = false)}
      >
        <div style="cursor: pointer;" @click=${this.onDropdownClicked}>
          <slot></slot>
        </div>
        ${this.isOpened
          ? html`
              <div
                class=${classMap({
                  'dropdown-content': true,
                  show: true,
                })}
                style=${styleMap({
                  position: 'fixed',
                  'min-width': this.minWidth ? `${this.minWidth}px` : '250px',
                  width: this.width ? `${this.width}px` : 'auto',
                  height: this.height ? `${this.height}px` : 'auto',
                  ...(this.marginLeft
                    ? {
                        'margin-left': this.marginLeft,
                      }
                    : {
                        'margin-left': this.left ? '-375px' : '-220px',
                      }),

                  'margin-top': this.left ? '-5px' : '',
                })}
              >
                <slot name="first-item"></slot>
                ${this.menuItems.map(
                  (i) =>
                    html`
                      <div
                        class=${classMap({
                          item: this.itemCss,
                          padding: this.paddingCss,
                          border: this.border,
                          hover: i.read,
                        })}
                        @click=${() => {
                          this.dispatchEvent(new CustomEvent('itemClicked', { detail: i }));
                          if (!this.staysOpenOnClick) {
                            this.isOpened = false;
                          }
                        }}
                      >
                        ${i.html ? i.html : translate(i)}
                      </div>
                    `
                )}
                <slot name="last-item"></slot>
              </div>
            `
          : ''}
      </div>
    `;
  },
})
export class DropdownComponent extends LitElement {
  @property({ type: Boolean }) isOpened = false;
  @property({ type: Boolean }) staysOpenOnClick: boolean;
  @property({ type: Array }) menuItems = [];
  @property({ type: Boolean }) left: boolean;
  @property({ type: String }) marginLeft: string;
  @property({ type: String }) $style = '';

  @property({ type: Boolean })
  itemCss = true;

  @property({ type: Boolean })
  paddingCss = true;

  @property({ type: Boolean }) border: boolean;
  @property({ type: Number }) height: number;
  @property({ type: Number }) width: number;
  @property({ type: Number }) minWidth: number;

  @property({ type: Object }) defaultTemplate = html` <button class="dropbtn">Dropdown</button> `;

  private entered: boolean;

  OnInit() {
    fromEvent(document, 'click')
      .pipe(filter(() => !this.entered))
      .subscribe(() => (this.isOpened = false));
  }

  private onDropdownClicked() {
    this.isOpened = !this.isOpened;
    this.dispatchEvent(new CustomEvent('buttonClicked'));
  }
}
